<template>
  <div class="first-read-packet-modal" v-if="show">
    <div class="shadow"></div>
    <div class="content">
      <div class="bg2">
        <div class="amount">{{amount}}</div>
      </div>
      <div class="bg1">
        <div class="btn" @click="goToFirst">领取红包</div>
      </div>
      <div class="close" @click="close"></div>
    </div>
  </div>
</template>
<script>
  import {getOrderWelfareAPI} from "../api/common";
  import {getFirstHBUrl} from "../constants";

  export default {
    vuex: {
      getters: {
        userInfo: state => state.user.user,
        isLogin: state => state.user.isLogined,

      }
    },
    data() {
      return {show: false, amount: '-'}
    },
    watch: {
      isLogin(isLogin) {
        if (isLogin)
//          if (!localStorage[this.userInfo.phone + '_firstorder'])
            getOrderWelfareAPI().then(res => {
              if (res.isOk) {
                if (res.data.isFirstOrder) {
                  this.show = true;
                  this.amount = res.data.amount;
                } else {
                  localStorage[this.userInfo.phone + '_firstorder'] = true
                }
              }
            });
      }
    },
    methods: {
      close() {
        this.show = false
      },
      goToFirst() {
        window.open(getFirstHBUrl(this.userInfo.phone, this.amount));
      }
    }
  }
</script>
<style lang="less" scoped>
  .first-read-packet-modal {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10000;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .shadow {
      z-index: -1;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.6)
    }
    .content {
      margin-top: -100px;
      border-radius: 2px;
      display: flex;
      flex-direction: column;
      position: relative;
      .bg1 {
        background-image: url("/static/img/bg_first_red_packet_1.png");
        background-size: contain;
        background-repeat: no-repeat;
        width: 230px;
        height: 170px;
        margin-top: 84px;
        display: flex;
        justify-content: center;
        .btn {
          background: #fde928;
          width: 165px;
          height: 46px;
          border-radius: 23px;
          margin-top: 100px;
          color: #e43936;
          font-weight: normal;
          line-height: 46px;
          text-align: center;
          font-size: 18px;
        }
      }

      .bg2 {
        z-index: -1;
        background-image: url("/static/img/bg_first_red_packet_2.png");
        background-size: contain;
        background-repeat: no-repeat;
        width: 230px;
        height: 255px;
        position: absolute;
        top: 0;
        .amount {
          margin-top: 48px;
          color: #e23734;
          font-size: 75px;
          font-weight: bold;
          margin-left: 35px;
          transform: rotate(-4deg);
        }
      }

      .close {
        z-index: -1;
        background-image: url("/static/img/ic_first_red_close.png");
        background-size: contain;
        background-repeat: no-repeat;
        width: 30px;
        height: 30px;
        position: absolute;
        top: -30px;
        right: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// FirstRedPacketModal.vue?04de0068